export default "__VITE_ASSET__DtdjnVD8__"